import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Ingrid extends Lit3formBlock {
  static get characterName() {
    return 'ingrid';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid ingrid-layout">
          <h2>${unsafeHTML(this.headerStr)}</h2>
          <p class="description">${unsafeHTML(this.descriptionStr)}</p>
          <div class="cta-wrapper">
            <cta-text
              cta-data=${this.ctaData()}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaData(),
                this.headerStr
              )}
            ></cta-text>
          </div>
          <div class="images">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    if (!!image.header) {
      return html`
        <div class="image-wrapper">
          <div class="image">
            <img src=${this.imageUrl(image)} />
            ${this.imageHeaderHTML(image)} ${this.imageDescriptionHTML(image)}
            ${this.imageCtaHTML(image)}
          </div>
        </div>
      `;
    } else {
      return html`
        <div class="image">
          <img src=${this.imageUrl(image)} />
        </div>
      `;
    }
  }

  imageHeaderHTML(image) {
    return !!image.header
      ? html`
          <h3 class="type-label">
            ${unsafeHTML(this.withLineBreaks(image.header))}
          </h3>
        `
      : html``;
  }

  imageDescriptionHTML(image) {
    return !!image.description
      ? html`
          <p class="font-size-small">
            ${unsafeHTML(this.withLineBreaks(image.description))}
          </p>
        `
      : html``;
  }

  imageCtaHTML(image) {
    return !!image.cta
      ? html`
          <div class="cta-wrapper image-cta">
            <cta-text
              cta-data=${this.ctaData(image)}
              .ctaAnalyticsData=${analyticsCtaDataObject(image, this.headerStr)}
            ></cta-text>
          </div>
        `
      : html``;
  }

  imageUrl(img) {
    return this.imagebossUrl(img.src, 370, null);
  }

  ctaData(image) {
    let cta;
    if (image) {
      cta = image.cta;
    } else {
      cta = this.content.cta;
    }
    return JSON.stringify(cta);
  }

  imageDescription(img) {
    return img.description || '';
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionStr() {
    return this.withLineBreaks(this.content.description) || '';
  }
}
Ingrid.defineElement();
